export default {
  buttons: {
    save: 'Zapisz',
  },
  error_messages: {
    product_unavailable: 'Wyprzedane!',
  },
};
